import React from 'react';

function GuidedTour({
  isOpen,
  currentStep,
  stepIndex,
  totalSteps,
  tooltipStyle,
  onBack,
  onNext,
  onSkip
}) {
  if (!isOpen || !currentStep) return null;

  return (
    <div className="tour-overlay" role="dialog" aria-modal="true" aria-label="Guided tour">
      <div className="tour-tooltip" style={tooltipStyle}>
        <div className="tour-tooltip-header">
          <strong>{currentStep.title}</strong>
          <span>{stepIndex + 1} / {totalSteps}</span>
        </div>
        <p>{currentStep.description}</p>
        <div className="tour-tooltip-actions">
          <button type="button" className="btn-delete" onClick={onSkip}>
            Skip
          </button>
          <div className="tour-tooltip-nav">
            <button
              type="button"
              className="btn-edit"
              onClick={onBack}
              disabled={stepIndex === 0}
            >
              Back
            </button>
            <button type="button" className="btn-edit" onClick={onNext}>
              {stepIndex === totalSteps - 1 ? 'Finish' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuidedTour;
